import React from 'react';
import { FaStar } from 'react-icons/fa';

const QuoteRequests = () => {
  return (
    <div className="space-y-6">
      <div className="text-center py-12">
        <div className="w-24 h-24 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <FaStar className="text-3xl text-slate-400" />
        </div>
        <h3 className="text-lg font-semibold text-slate-800 mb-2">Quote Requests Management</h3>
        <p className="text-slate-600">Quote requests management will be implemented here.</p>
      </div>
    </div>
  );
};

export default QuoteRequests;